import React, { HTMLProps, useCallback, useEffect, useRef, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { clearInput } from 'tennders-stracture/libs/utils'
import { get, isArray } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import ClearInputButton from '../ClearInputButton'

export type SearchProps = Omit<HTMLProps<HTMLInputElement>, 'ref' | 'onChange' | 'value' | 'name'> & {
  onSet ?: (value: any) => void
  value ?: any
  error ?: string,
  name ?: string,
  buttonStyle ?: any,
  searchPlaceholder ?: string
}

const Search = (props: SearchProps) => {
  const {
    onSet,
    readOnly,
    className,
    value,
    error,
    buttonStyle,
    searchPlaceholder,
    ...rest
  } = props
  const { t } = useTranslation()
  const [inputValue, setInputValue] = useState(null)
  const [cursor, setCursor] = useState(null)
  const ref = useRef(null)

  const onFormChange = (e) => {
    if (readOnly) {
      return
    }
    if (onSet) {
      setCursor(e.target.selectionStart)
      onSet(String(e.target?.value))
      setInputValue(e.target?.value)
    }
  }

  const handleClearInput = useCallback(() => clearInput(onSet, inputValue[0], setInputValue), [onSet, inputValue, setInputValue])

  useEffect(() => {
    if (value) {
      setInputValue([value])
    } else {
      setInputValue('')
    }
  }, [value])

  useEffect(() => {
    const input = ref.current
    if (input) {
      input.setSelectionRange(cursor, cursor)
    }
  }, [ref, cursor, inputValue])

  return (
    <div className="tennders-search m-auto">
      <input
        autoComplete="new-password"
        placeholder={searchPlaceholder || t('searchFilters:searchDirectory')}
        className={`${className || 'form-input w-100'}${error ? ' error' : ''}`}
        value={get(inputValue, 'length') > 0 ? isArray(inputValue) ? inputValue[0] : inputValue : ''}
        type="text"
        onChange={onFormChange}
        {...rest}
      />
      <button style={buttonStyle} type="button"><FontAwesomeIcon icon={faSearch} aria-hidden="true" /> </button>
      <ClearInputButton clearInput={handleClearInput} showClearInput={get(inputValue, 'length') > 0} />
    </div>
  )
}

export default React.memo(Search)
